module.exports = __webpack_public_path__ + "media/stylesheets/images/media/logo-userway-d319465f380641d0095b90f56cbbd818.png";